import {isAfter, isBefore, isEqual} from "date-fns";

export const compareDates = (a: Date, b: Date): number => {
  return a.getTime() - b.getTime();
};

type TypeComparer<T> = (a: T, b: T) => number;

export const objectDatesComparer = <T,>(getter: (obj: T) => Date): TypeComparer<T> => {
  return (a: T, b: T): number => {
    return compareDates(getter(a), getter(b));
  };
};

export const isAfterOrEqual = (date: Date, dateToCompare: Date): boolean => {
  return isEqual(date, dateToCompare) || isAfter(date, dateToCompare);
};

export const isBeforeOrEqual = (date: Date, dateToCompare: Date): boolean => {
  return isEqual(date, dateToCompare) || isBefore(date, dateToCompare);
};

export function formatDate(date: Date): string {
  const year: number = date.getFullYear();
  // getMonth() returns month from 0-11, so add 1 and pad with leading zero if needed
  const month: string = String(date.getMonth() + 1).padStart(2, "0");
  // getDate() returns the day of the month, pad with leading zero if needed
  const day: string = String(date.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
}
